export default __webpack_public_path__ + "static/media/square_foot_icon_b.db1a6c2b.svg";